import * as _ from 'lodash';
import { Component } from 'react';
import { Dispatch, connect } from 'react-redux';
import { IApplicationState, AppActionCreators, UserActionCreators, IGroupListResponse, IGroupLookupDataResponse, IGroupData, IAddUpdateGroupResponse } from '@nkr/store/index';
import { IGroup, IListItem } from '@nkr/models/index';
import { toast } from 'react-toastify';
import GroupGrid from './group-grid';
import GroupAddEdit from './group-add-edit/index';

interface IOwnProps { }

interface IStateProps {
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getGroups: () => Promise<IGroupListResponse>,
    getGroupLookupData: () => Promise<IGroupLookupDataResponse>
    updateGroup: (data: IGroupData) => Promise<IAddUpdateGroupResponse>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;


interface IState {
    list: IGroup[],
    ticketGroupList: IListItem[],
    addEdit: {
        show: boolean,
        data: IGroup
    }
}

class GroupList extends Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        ticketGroupList: [],
        addEdit: {
            show: false,
            data: null
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Loading users, one moment please...').then(() => {
            Promise.all([
                this.props.getGroups(),
                this.props.getGroupLookupData()
            ])
                .then(([groupListResponse, groupLookupResponse]) => {
                    if (groupListResponse.data.success && groupLookupResponse.data.success) {
                        this.setState({
                            list: groupListResponse.data.results,
                            ticketGroupList: groupLookupResponse.data.results.ticketGroupList
                        });

                        this.props.hideLoading();
                    }
                });
        });
    }

    handleEdit = (id: number) => {
        let data = this.state.list.find(x => x.id == id);
        this.setState({
            addEdit: {
                show: true,
                data
            }
        });
    }

    handleSave = (data: IGroupData) => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Saving group, one moment please...').then(() => {
                this.props.updateGroup(data)
                    .then(response => {
                        if (response.data.success) {
                            let list = _.cloneDeep(this.state.list).map(item => {
                                if (item.id == data.id) {
                                    return response.data.results;
                                }

                                return item;
                            });

                            this.setState({
                                list
                            }, () => {
                                toast.success('Group updated successfully');
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelEdit = () => {
        this.setState({
            addEdit: {
                show: false,
                data: null
            }
        });
    }

    render = () => {
        return (
            <>
                <div className='container-fluid'>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
                        <div>
                            <h1 style={{ margin: 0 }}>User Groups</h1>
                        </div>
                        {/* <div>
                            <Button bsStyle='primary' onClick={this.handleAdd}>Add User</Button>
                        </div> */}
                    </div>

                    <GroupGrid
                        data={this.state.list}
                        onEdit={this.handleEdit}
                    />
                </div>

                <GroupAddEdit
                    show={this.state.addEdit.show}
                    data={this.state.addEdit.data}
                    ticketGroupList={this.state.ticketGroupList}
                    onSave={this.handleSave}
                    onCancel={this.handleCancelEdit} />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        // groups: state.users.groups
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getGroups: () => {
            return dispatch(UserActionCreators.getGroups());
        },
        getGroupLookupData: () => {
            return dispatch(UserActionCreators.getGroupLookupData());
        },
        updateGroup: (data) => {
            return dispatch(UserActionCreators.updateGroup(data));
        },
        // getLookupData: () => {
        //     return dispatch(UserActionCreators.getLookupData());
        // },
        // deleteUser: (userId) => {
        //     return dispatch(UserActionCreators.deleteUser(userId));
        // },
        // saveUser: (id, firstName, lastName, email, username, password, groupId, centerId, roles, sendTicketNotification) => {
        //     return dispatch(UserActionCreators.saveUser(id, firstName, lastName, email, username, password, groupId, centerId, roles, sendTicketNotification));
        // }
    });
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(GroupList);